import React, { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { apiURL } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { getEProcode, getMobileNo } from "../../selector/auth.selector";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";
import { setLanguageNumber } from "../../reducer/language.reducer";
import {
  getLanguage,
  getLanguageNumber,
} from "../../selector/language.selector";
import useInstruction from "../Instruction/useInstruction";
const useLanguage = () => {
  //   const [SubjectDetails, setSubjectDetails] = useState([]);
  const mobileNo = useSelector(getMobileNo);
  const Language = useSelector(getLanguage);
  const eProcode = useSelector(getEProcode);
  const { fetchInstruction, Instructions } = useInstruction();
  //   const number = useSelector(getLanguageNumber);
  const dispatch = useDispatch();
  const updateLanguages = useCallback(async (number) => {
    try {
      dispatch(showPageLoader());

      const { data } = await Api.post({
        url: apiURL.updateLanguage(),
        params: {
          ePROCODE: eProcode,
          LanguageType: number,
        },
      });
      if (data.Message === "Language updated sucessfully") {
        fetchInstruction();
      }
      dispatch(hidePageLoader());
    } catch (error) {
      dispatch(hidePageLoader());
      console.log("error==>", error);
    }
  }, []);
  return { updateLanguages };
};

export default useLanguage;
